import { command, Command } from "@lookiero/messaging";

const RECONCILIATE_CHECKOUT_BOOKING = "reconciliate_checkout_booking";

interface ReconciliateCheckoutBookingPayload {
  readonly aggregateId: string;
  /* Carried over to checkoutBookingExpired so its process managers can act on the checkout */
  readonly checkoutId: string;
}

interface ReconciliateCheckoutBooking
  extends Command<typeof RECONCILIATE_CHECKOUT_BOOKING>, ReconciliateCheckoutBookingPayload {}

interface ReconciliateCheckoutBookingFunction {
  (payload: ReconciliateCheckoutBookingPayload): ReconciliateCheckoutBooking;
}

const reconciliateCheckoutBooking: ReconciliateCheckoutBookingFunction = ({ aggregateId, checkoutId }) => ({
  ...command({ aggregateId, name: RECONCILIATE_CHECKOUT_BOOKING }),
  checkoutId,
});

export type { ReconciliateCheckoutBooking };
export { RECONCILIATE_CHECKOUT_BOOKING, reconciliateCheckoutBooking };
